<template>
  <div class="countries-ranking stat-container">
    <div class="head">
      <h2>&nbsp;
        <transition name="fade">
          <span :key="filter.id">{{ filter.label }}</span>
        </transition>
    </h2>
    </div>
    <div class="rankings">
      <div class="row label">
        <div></div>
        <div>Rang</div>
        <div></div>
        <div></div>
      </div>
      <div class="row"
        v-for="(ranking) in rankings"
        :class ="{'is-selected' : ranking.selected}">
          <div class="land" :class="['land-'+ ranking.id ]">
          <transition name="fade">
            <span :key="ranking.land">
              {{ ranking.land }}
            </span>
          </transition>
          </div>
          <div class="rang-wrapper">
            <div class="rang">
              <AnimatedValue v-bind:value="ranking.rang"></AnimatedValue>
            </div>
          </div>
          <div class="bar-wrapper">
            <div
            v-bind:style="{ width: Math.round(ranking.value) + '%' }"
            v-bind:class="{ bar: true, animateWidth: true }">
              <AnimatedValue v-bind:isFloat="true" v-bind:value="ranking.value"></AnimatedValue>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedValue from '@/components/AnimateValue.vue';

export default {
  name: 'countriesranking',
  components: {
    AnimatedValue,
  },
  computed: {
  },
  mounted: () => {
  },
  methods: {
  },
  data: () => ({
  }),
  props: {
    rankings: null,
    filter: null,
    selectedStat: null,
  },
};
</script>

<style scoped lang="scss">
.countries-ranking {
  border: 1px solid $color-border;
  border-radius: $border-radius;
  background-color: $color-bg-widget;
  .row {
    display: grid;
    grid-template-columns: 35% auto 55%;
    padding-top: $padding-min;
    @extend .animateOpacity;

    &.is-selected {
      color: $color-bar-highlight;
      .bar {
        background-color: $color-bar-highlight;
      }
    }
    > div:last-child {
      justify-self: right;
      align-self: end;
    }
  }
  .head {
    height: 31px;
    padding: $padding-default;
    background-color: $color-bg-headline;
    color: $color-text-headline;
    text-align: left;
    display: flex;
    align-content: center;
  }
  h2 {
    position: relative;
    width: 100%;
    font-size: 18px;
    justify-self: start;
    text-transform: uppercase;

    span {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .rankings {
    width: 80%;
    margin: 0 auto;
    padding: 0 0 $padding-default;

    @include bp(s) {
      width: 95%;
    }
  }
  .rang-wrapper {
    position: relative;
    margin: 0 auto;
  }
  .land {
    position: relative;
    white-space: nowrap;

    span {
      position: absolute;
      top: 0;
      right: 0;
    }

    &.land-gb {
      font-size: 12px;
    }
  }
  .rang {
    width: 18px;
    height: 18px;
    background-color: $color-brand;
    border-radius: 50%;
    color: $color-white;
    line-height: 18px;
    font-size: 10px;
  }
  .border-wrapper {
    position: relative;
    border-left: 100px solid red;
  }
  .border {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 1px;
    background-color: $color-brand;
  }
  .bar-wrapper {
    position: relative;
    width: calc(100% - 20px);
    height: 17px;
    background-color: $color-bg-bar;

    .bar {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0;
      background-color: $color-brand;
      color: $color-white;
      text-align: right;
      padding-right: 11px;
      line-height: 19px;
    }
  }
}
</style>
